import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import Dropdown from 'af-components/Controls/Dropdown';

import * as ItemCategoryActions from 'af-actions/itemCategory';

import styles from './styles.module.scss';

export interface CategoryFilterOption {
	id: number;
	label: string;
}
interface OwnProps {
	onChange: (option: Nullable<CategoryFilterOption>) => void;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const CrewTypeFilter: React.FC<Props> = (props) => {

	const {
		onChange,
		findAll,
	} = props;

	const [options, setOptions] = React.useState<CategoryFilterOption[]>([]);

	const fetchOptions = React.useCallback(async () => {
		const _options = await findAll();
		const formattedOptions = _options.map((option) => ({
			id: option.id,
			label: option.name,
		}));
		setOptions(formattedOptions);
	}, [findAll]);

	React.useEffect(() => {
		fetchOptions();
	}, [fetchOptions]);

	const renderOption = React.useCallback((option: CategoryFilterOption) => {
		return (
			<>
				{option.label}
			</>
		);
	}, []);

	const filterBy = React.useCallback((option: CategoryFilterOption, rawInput: string) => {
		return option.label.toLowerCase().includes(rawInput.toLowerCase());
	}, []);

	return (
		<div className={styles.dropdown}>
			<Dropdown<CategoryFilterOption>
				filterable={true}
				filterBy={filterBy}
				hasBlankOption={true}
				onValueChange={onChange}
				options={options}
				placeholder="Select Category"
				renderMenuItem={renderOption}
				valueKey={'id'}
				withCaret={true}
			/>
		</div>
	);
};

function mapDispatchToProps() {
	return {
		findAll: ItemCategoryActions.findList,
	};
}

const connector = connect(null, mapDispatchToProps());

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector
);

export default enhance(CrewTypeFilter);
